<template>
  <div class="page-content">
    <div class="content-wrapper">
      <!-- Page header -->
      <div class="page-header">
        <div class="page-header-content header-elements-md-inline">
          <div class="page-title d-flex">
            <h4 class="font-weight-semibold">Accuracy Analytic</h4>
          </div>
        </div>
      </div>

      <div class="content">
        <div class="row">
          <div class="col-9">
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <h4
                    class="card-header font-weight-semibold d-flex justify-content-between"
                  >
                    <div>Internal Edit</div>
                  </h4>
                  <div class="card-body">
                    <div class="pb-3">
                      <form ref="internalEditForm" @submit.prevent>
                        <div class="custom-file">
                          <input
                            @change="uploadInternal"
                            type="file"
                            id="internal-edit"
                            aria-describedby="internal-edit"
                          />
                          <label class="custom-file-label" for="internal-edit"
                            >Choose Internal File</label
                          >
                        </div>
                      </form>
                      <div class="text-success" v-if="internalMsg">
                        {{ internalMsg }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="card">
                  <h4 class="card-header font-weight-semibold">
                    <div>Client Edit</div>
                  </h4>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-6">
                        <div>
                          <form ref="clientEditForm" @submit.prevent>
                            <div class="custom-file">
                              <input
                                @change="uploadClient"
                                type="file"
                                id="client-edit"
                                aria-describedby="client-edit"
                              />
                              <label class="custom-file-label" for="client-edit"
                                >Choose Client File</label
                              >
                            </div>
                          </form>
                          <div class="text-success" v-if="clientMsg">
                            {{ clientMsg }}
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="d-flex">
                          <div class="mr-2">
                            <date-picker
                              v-model="createDate"
                              type="month"
                              placeholder="Date"
                              value-type="YYYY-MM-DD"
                              format="MMM YYYY"
                            ></date-picker>
                          </div>
                          <div>
                            <select
                              class="form-control"
                              v-model="templateStatus"
                            >
                              <option value="old">Old template</option>
                              <option value="new">New template</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div>
                      <label class="mr-2" for="date">Select Date</label>
                      <date-picker
                        id="date"
                        type="month"
                        placeholder="Date"
                        v-model="selectedDate"
                        value-type="YYYY-MM"
                        format="MMM YYYY"
                      ></date-picker>
                    </div>
                    <div v-if="loading">Loading...</div>
                    <div v-else>
                      <div v-if="series.length">
                        <div>
                          <apexchart
                            :height="300"
                            class="d-flex justify-content-center"
                            type="line"
                            :options="{
                              title: {
                                text: 'Overall'
                              },
                              ...chartOptions
                            }"
                            :series="series"
                          ></apexchart>
                        </div>

                        <hr />

                        <div class="row">
                          <div class="col-4">
                            <apexchart
                              class="d-flex justify-content-center"
                              type="line"
                              :options="{
                                title: {
                                  text: 'Negative'
                                },
                                ...chartOptions
                              }"
                              :series="negativeChanges"
                            ></apexchart>
                          </div>
                          <div class="col-4">
                            <apexchart
                              class="d-flex justify-content-center"
                              type="line"
                              :options="{
                                title: {
                                  text: 'Neutral'
                                },
                                ...chartOptions
                              }"
                              :series="neutralChanges"
                            ></apexchart>
                          </div>
                          <div class="col-4">
                            <apexchart
                              class="d-flex justify-content-center"
                              type="line"
                              :options="{
                                title: {
                                  text: 'Positive'
                                },
                                ...chartOptions
                              }"
                              :series="positiveChanges"
                            ></apexchart>
                          </div>
                        </div>
                      </div>

                      <div v-else>
                        <h5>No Data</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="card h-100">
              <div class="card-header">
                Upload History
              </div>
              <div class="card-body">
                <div
                  class="d-flex justify-content-between"
                  :key="i"
                  v-for="(h, i) in history"
                >
                  <span>{{ h.excelName }}</span>
                  <i class="icon-spinner2 spinner" v-if="!h.isFinish"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import serviceRoutes from '../../service-routes'
import VueApexCharts from 'vue-apexcharts'

// const aaa = {
//   data: {
//     columnName: [
//       'Sub Attribute',
//       'Intention',
//       'sentiment',
//       'Branding character',
//       'Brand',
//       'Product group',
//       'Product/Other',
//       'Attribute',
//       'Channel',
//       'Sensitive Area',
//       'summary'
//     ],
//     data: [
//       {
//         'Sub Attribute': 12730,
//         Intention: 2845,
//         sentiment: 2517,
//         'Branding character': 4658,
//         Brand: 4606,
//         'Product group': 1614,
//         'Product/Other': 4607,
//         Attribute: 1486,
//         Channel: 1199,
//         'Sensitive Area': 29,
//         summary: 36291,
//         update_at: '2024-02-01T09:10:27.002Z'
//       },
//       {
//         'Product/Other': 6635,
//         Brand: 5983,
//         'Product group': 2357,
//         'Sub Attribute': 3622,
//         'Branding character': 2049,
//         Attribute: 2487,
//         'Sensitive Area': 72,
//         Intention: 4235,
//         sentiment: 4176,
//         Channel: 1763,
//         summary: 33379,
//         update_at: '2024-01-14T17:00:00.000Z'
//       }
//     ],
//     changeData: [
//       {
//         _id: '65bb60a37750b18d7b31b50b',
//         fileName: 'Raw Data 1-31 Aug 2023_all_incidentv2.xlsx',
//         allRecordCount: '51875',
//         allChange: {
//           'Sub Attribute': '24.54% (12730/51875)',
//           Brand: '8.88% (4606/51875)',
//           Intention: '5.48% (2845/51875)',
//           sentiment: '4.85% (2517/51875)',
//           Channel: '2.31% (1199/51875)',
//           Attribute: '2.86% (1486/51875)',
//           'Branding character': '8.98% (4658/51875)',
//           'Product group': '3.11% (1614/51875)',
//           'Product/Other': '8.88% (4607/51875)',
//           'Sensitive Area': '0.06% (29/51875)',
//           summary: '7.00% (36291/518750)'
//         },
//         positiveChange: {
//           'Sub Attribute': '10.86% (213/1962)',
//           Brand: '5.96% (117/1962)',
//           Intention: '11.31% (222/1962)',
//           sentiment: '10.96% (215/1962)',
//           Channel: '1.53% (30/1962)',
//           Attribute: '3.47% (68/1962)',
//           'Branding character': '5.50% (108/1962)',
//           'Product group': '2.24% (44/1962)',
//           'Product/Other': '4.08% (80/1962)',
//           'Sensitive Area': '0.05% (1/1962)',
//           summary: '5.60% (1098/19620)'
//         },
//         neutralChange: {
//           Intention: '5.82% (2139/36723)',
//           sentiment: '5.03% (1848/36723)',
//           'Sub Attribute': '31.05% (11404/36723)',
//           'Branding character': '10.85% (3986/36723)',
//           Brand: '10.80% (3967/36723)',
//           'Product group': '3.19% (1171/36723)',
//           'Product/Other': '9.23% (3388/36723)',
//           Attribute: '2.02% (743/36723)',
//           Channel: '1.79% (656/36723)',
//           'Sensitive Area': '0.07% (26/36723)',
//           summary: '7.99% (29328/367230)'
//         },
//         negativeChange: {
//           'Sub Attribute': '8.44% (1113/13190)',
//           Intention: '3.67% (484/13190)',
//           sentiment: '3.44% (454/13190)',
//           Attribute: '5.12% (675/13190)',
//           'Branding character': '4.28% (564/13190)',
//           'Product group': '3.03% (399/13190)',
//           'Product/Other': '8.64% (1139/13190)',
//           Brand: '3.96% (522/13190)',
//           Channel: '3.89% (513/13190)',
//           'Sensitive Area': '0.02% (2/13190)',
//           summary: '4.45% (5865/131900)'
//         },
//         updateAt: '2024-02-01T09:10:27.002Z'
//       },
//       {
//         _id: '65bb63aca54a4c8cc5c2b4cc',
//         fileName: 'Raw data_1-30 Apr 2023_all_incident_FinaL.xlsx',
//         allRecordCount: '96009',
//         allChange: {
//           Brand: '6.23% (5983/96009)',
//           'Product/Other': '6.91% (6635/96009)',
//           'Product group': '2.45% (2357/96009)',
//           'Sub Attribute': '3.77% (3622/96009)',
//           'Branding character': '2.13% (2049/96009)',
//           Attribute: '2.59% (2487/96009)',
//           'Sensitive Area': '0.07% (72/96009)',
//           Channel: '1.84% (1763/96009)',
//           Intention: '4.41% (4235/96009)',
//           sentiment: '4.35% (4176/96009)',
//           summary: '3.48% (33379/960090)'
//         },
//         positiveChange: {
//           'Product/Other': '4.71% (176/3738)',
//           Brand: '14.29% (534/3738)',
//           Channel: '2.78% (104/3738)',
//           'Product group': '3.50% (131/3738)',
//           Attribute: '4.17% (156/3738)',
//           'Sub Attribute': '6.61% (247/3738)',
//           'Branding character': '4.12% (154/3738)',
//           Intention: '10.49% (392/3738)',
//           sentiment: '10.49% (392/3738)',
//           summary: '6.12% (2286/37380)'
//         },
//         neutralChange: {
//           Brand: '7.17% (4607/64247)',
//           'Product/Other': '6.07% (3900/64247)',
//           'Product group': '1.89% (1212/64247)',
//           'Sub Attribute': '1.89% (1217/64247)',
//           'Branding character': '0.92% (588/64247)',
//           Attribute: '0.66% (425/64247)',
//           'Sensitive Area': '0.10% (62/64247)',
//           Channel: '0.39% (251/64247)',
//           Intention: '0.40% (258/64247)',
//           sentiment: '0.33% (211/64247)',
//           summary: '1.98% (12731/642470)'
//         },
//         negativeChange: {
//           'Product group': '3.62% (1014/28024)',
//           'Product/Other': '9.13% (2559/28024)',
//           Intention: '12.79% (3585/28024)',
//           sentiment: '12.75% (3573/28024)',
//           Brand: '3.00% (842/28024)',
//           Attribute: '6.80% (1906/28024)',
//           'Sub Attribute': '7.70% (2158/28024)',
//           'Branding character': '4.66% (1307/28024)',
//           Channel: '5.02% (1408/28024)',
//           'Sensitive Area': '0.04% (10/28024)',
//           summary: '6.55% (18362/280240)'
//         },
//         updateAt: '2024-01-14T17:00:00.000Z'
//       }
//     ]
//   }
// }

export default {
  components: { apexchart: VueApexCharts },
  data () {
    return {
      intervalId: null,
      history: [],
      loading: false,
      colNames: [],
      summaries: [],
      positiveChanges: [],
      negativeChanges: [],
      neutralChanges: [],

      chartOptions: {
        title: { text: 'Statistic', align: 'left' }
      },

      series: [],

      internalStats: [],
      clientStats: [],

      internalMsg: null,
      clientMsg: null,
      selectedDate: null,

      createDate: null,
      templateStatus: 'old'
    }
  },

  methods: {
    async getStats () {
      this.intervalId = setInterval(async () => {
        let resData = await serviceRoutes.getAnalyticFiles()
        this.history = resData.data
      }, 10000)
    },
    async uploadInternal (e) {
      let file = e.target.files[0]
      if (file) {
        this.internalMsg = `${file.name} is uploading.`
        let result = await serviceRoutes.uploadInternalEdit(file)
        if (result) {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Upload internal edit sucess',
            showConfirmButton: false,
            timer: 0
          })
        } else {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: 'Upload internal edit error',
            showConfirmButton: false,
            timer: 0
          })
        }
        this.$refs.internalEditForm.reset()
      }
    },
    async uploadClient (e) {
      let file = e.target.files[0]
      if (file) {
        this.clientMsg = `${file.name} is uploading.`
        let result = await serviceRoutes.uploadClientEdit(
          file,
          this.createDate,
          this.templateStatus === 'old'
        )
        if (result) {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Upload client edit sucess',
            showConfirmButton: false,
            timer: 0
          })
        } else {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: 'Upload client edit error',
            showConfirmButton: false,
            timer: 0
          })
        }
      }
      this.$refs.clientEditForm.reset()
    },
    resetCharts () {
      this.positiveChanges = []
      this.negativeChanges = []
      this.neutralChanges = []
      this.series = []
    },
    async getAnalyticSummary () {
      this.loading = true

      if (this.$swal && typeof this.$swal.close === 'function') {
        this.$swal.close()
      }
      this.resetCharts()

      // let resData = aaa
      let resData = await serviceRoutes
        .getAnalyticSummary(this.selectedDate)
        .catch(e => {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: e.response.data.data || 'Something went wrong',
            showConfirmButton: false,
            timer: 5000
          })
        })
      if (resData) {
        let result = resData.data

        let chart = this.getChartData(
          result.columnName,
          this.formatChange(result.columnName, result.changeData, 'allChange')
        )
        this.series = chart.series
        this.chartOptions = chart.chartOption

        let positiveChart = this.getChartData(
          result.columnName,
          this.formatChange(
            result.columnName,
            result.changeData,
            'positiveChange'
          )
        )
        let negativeChart = this.getChartData(
          result.columnName,
          this.formatChange(
            result.columnName,
            result.changeData,
            'negativeChange'
          )
        )
        let neutralChart = this.getChartData(
          result.columnName,
          this.formatChange(
            result.columnName,
            result.changeData,
            'neutralChange'
          )
        )

        this.positiveChanges = positiveChart.series
        this.negativeChanges = negativeChart.series
        this.neutralChanges = neutralChart.series
      }
      this.loading = false
    },
    formatChange (
      columns,
      changes,
      type /* positiveChange,negativeChange,neutralChange */
    ) {
      let data = []
      for (let change of changes) {
        let result = {}
        result.update_at = change.updateAt
        for (let col of columns) {
          let value = change[type][col]
          result[col] = 0
          if (value) {
            result[col] = parseFloat(value)
          }
        }
        data.push(result)
      }
      return data
    },
    getChartData (columnNames, summaries) {
      let series = []
      let dates = summaries.map(v => moment(v.update_at).format('MMM YYYY'))
      for (let col of columnNames) {
        let data = []
        for (let summary of summaries) {
          data.push(summary[col])
        }
        series.push({ data, name: col })
      }
      return {
        series,
        chartOption: {
          markers: {
            size: 3
          },
          xaxis: {
            categories: dates
          },
          yaxis: {
            forceNiceScale: true,
            max: 100,
            labels: {
              formatter: value => `${value}%`
            },
            title: {
              text: 'Error'
            }
          },
          stroke: {
            curve: 'smooth',
            width: 2 // Set the thickness of the line
          }
        }
      }
    }
  },

  watch: {
    selectedDate (newV, oldV) {
      this.getAnalyticSummary()
    }
  },
  beforeDestroy () {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  mounted () {
    this.getStats()
  }
}
</script>

<style></style>
